export default "/images/Opportunity4.png?727f5fa4a3a583b6fc753f8eb21c8b79";